/**
 * B2B design tokens — logo anchor #0a1e40, balanced neutrals + accent.
 * Use via MUI theme (palette) or import in sx when needed.
 */
export const tokens = {
  brand: "#0a1e40",
  brandMuted: "#132f5c",
  brandDeep: "#061428",
  accent: "#2d6a8f",
  accentHover: "#245771",
  accentSoft: "rgba(45, 106, 143, 0.12)",
  highlight: "#c4a35a",
  highlightSoft: "rgba(196, 163, 90, 0.15)",
  surface: "#f4f6f9",
  surfaceAlt: "#eef2f7",
  paper: "#ffffff",
  border: "#e2e8f0",
  borderStrong: "#cbd5e1",
  text: "#0f172a",
  textMuted: "#64748b",
  textSubtle: "#94a3b8",
  success: "#0d7a5c",
  successSoft: "rgba(13, 122, 92, 0.12)",
  error: "#b91c1c",
  errorSoft: "rgba(185, 28, 28, 0.08)",
  radiusSm: 8,
  radiusMd: 12,
  radiusLg: 16,
  radiusXl: 20,
  shadowSm: "0 1px 2px rgba(10, 30, 64, 0.06)",
  shadowMd: "0 4px 24px rgba(10, 30, 64, 0.08)",
  shadowLg: "0 12px 40px rgba(10, 30, 64, 0.12)",
  fontSans: '"Plus Jakarta Sans", "Segoe UI", system-ui, sans-serif',
  fontDisplay: '"Fraunces", "Georgia", serif',
};

export default tokens;
